import React from "react";
import { DownloadCloud, Award } from "lucide-react";
import "./ResultYearSection.css";

const resultsData = [
  {
    year: 2024,
    selections: 150,
    topRanks: [
      { name: "Amit Sharma", rank: 3, photo: "https://randomuser.me/api/portraits/men/12.jpg" },
      { name: "Sneha Gupta", rank: 7, photo: "https://randomuser.me/api/portraits/women/44.jpg" },
    ],
    successRate: 78,
    specialMentions: "3 AIR in UPSC",
    pdfLink: "#",
  },
  {
    year: 2023,
    selections: 130,
    topRanks: [
      { name: "Rahul Mehta", rank: 1, photo: "https://randomuser.me/api/portraits/men/30.jpg" },
      { name: "Priya Singh", rank: 9, photo: "https://randomuser.me/api/portraits/women/55.jpg" },
    ],
    successRate: 74,
    specialMentions: "1 AIR in UPSC, 2 BPSC Toppers",
    pdfLink: "#",
  },
  {
    year: 2022,
    selections: 110,
    topRanks: [
      { name: "Karan Patel", rank: 5, photo: "https://randomuser.me/api/portraits/men/40.jpg" },
      { name: "Nisha Rao", rank: 10, photo: "https://randomuser.me/api/portraits/women/33.jpg" },
    ],
    successRate: 69,
    specialMentions: "2 AIR in PSC",
    pdfLink: "#",
  },
];

export default function ResultYearSection() {
  return (
    <section className="result-year-container" aria-labelledby="result-year-title">
      <header className="result-year-header">
        <h2 id="result-year-title">Year-wise Results & Achievements</h2>
        <p>See our consistent record of excellence through detailed yearly stats.</p>
      </header>

      <div className="result-year-table-wrapper" role="table" aria-label="Year wise results table">
        <table className="result-year-table">
          <thead>
            <tr>
              <th scope="col">Year</th>
              <th scope="col">Selections</th>
              <th scope="col">Top Ranks</th>
              <th scope="col">Success Rate (%)</th>
              <th scope="col">Special Mentions</th>
              <th scope="col" className="result-year-download-col" aria-label="Download official results"></th>
            </tr>
          </thead>
          <tbody>
            {resultsData.map(({ year, selections, topRanks, successRate, specialMentions, pdfLink }) => (
              <tr key={year} tabIndex={0}>
                <td className="result-year-cell-year">{year}</td>
                <td>{selections}</td>
                <td className="result-year-cell-topranks">
                  {topRanks.map(({ name, rank, photo }) => (
                    <div
                      key={name}
                      className="result-year-topper"
                      title={`${name} - AIR ${rank}`}
                    >
                      <img
                        src={photo}
                        alt={`${name} - Rank ${rank}`}
                        loading="lazy"
                        className="result-year-topper-img"
                      />
                      <span className="result-year-topper-rank" aria-label={`All India Rank ${rank}`}>
                        <Award size={14} /> {rank}
                      </span>
                    </div>
                  ))}
                </td>
                <td>{successRate}%</td>
                <td>{specialMentions}</td>
                <td className="result-year-download-col">
                  <a
                    href={pdfLink}
                    className="result-year-download-btn"
                    aria-label={`Download official results for year ${year}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <DownloadCloud size={20} /> PDF
                  </a>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
}
